import { AdapterGenerico } from '../Infraestructure/AdapterGenerico';
import './ComparativeSummaryCard.scss';

interface ComparativeSummaryCardProps {
    codigo: string;
    importe: number;
    monedaCodigo?: string;
    estado?: string;
    label: string;
    onCopyCode: () => void;
    className?: string;
}

export const ComparativeSummaryCard = (props: ComparativeSummaryCardProps) => {
    return (
        <div className={`ComparativeSummaryCard mb-3 ${props.className || ''}`}>
            <div className='ComparativeSummaryCard-top'>
                <div className='ComparativeSummaryCard-identity'>
                    <div className='ComparativeSummaryCard-code' onClick={props.onCopyCode}>
                        <span>{props.codigo}</span>
                        <button type='button' className='icon-copy-custom-light'><i className="fa-solid fa-copy" /></button>
                    </div>
                </div>
                {
                    props.estado &&
                    <span className='ComparativeSummaryCard-status'>{props.estado}</span>
                }
            </div>
            <div className='ComparativeSummaryCard-amount'>
                $ {AdapterGenerico.formatoDinero(props.importe)}
                {
                    props.monedaCodigo &&
                    <span className='ComparativeSummaryCard-currency'>{props.monedaCodigo}</span>
                }
            </div>
            <div className='ComparativeSummaryCard-label'>{props.label}</div>
        </div>
    )
}
